document.addEventListener("DOMContentLoaded", () => {
  const _el = {
    /**
     * Gets all the filter options lists
     * @returns {NodeList} A NodeList of all the filter options lists
     */
    optionsList: () =>
      document.querySelectorAll(
        "#boost-sd__filter-tree-wrapper .boost-sd__filter-option.boost-sd__filter-option-list"
      ),
    /**
     * Retrieves all the mobile filter options lists.
     * @returns {NodeList} A NodeList of all the mobile filter options lists.
     */
    optionsListMobile: () =>
      document.querySelectorAll(
        "#boost-sd_filter-tree-mobile .boost-sd__filter-option.boost-sd__filter-option-list"
      ),
    /**
     * Retrieves all the filter title elements in the desktop filter options.
     * @returns {NodeList} A NodeList of all the filter title elements.
     */
    filterTitlesDesktop: () =>
      document.querySelectorAll(
        "#boost-sd-filter-tree-column .boost-sd__filter-option-title"
      ),
  };
  const _fn = {
    /**
     * Initializes the Boost Product Filter plugin.
     * This function is called after the DOM content is fully loaded.
     * It calls the following functions in order:
     * 1. onChange
     * 2. bindEvents
     * 3. closeDesktopFilters
     * 4. setCounter with desktop options
     * 5. setCounterMobile with mobile options
     */
    init: () => {
      _fn.onChange();
      _fn.bindEvents();
      
      // Comment out the line below to stop forcing filters closed:
      // _fn.closeDesktopFilters();
      
      _fn.setCounter(_el.optionsList());
      _fn.setCounterMobile(_el.optionsListMobile());
    },
    /**
     * Sets up event listeners on the filter options items.
     * This function is called when the plugin is initialized.
     * It adds an event listener to each filter option item that calls the onChange function when clicked.
     */
    bindEvents: () => {
      const filterOptions = document.querySelectorAll(
        "#boost-sd__filter-tree-wrapper .boost-sd__filter-option-item-button"
      );

      filterOptions.forEach((item) => {
        item.addEventListener("click", (e) => _fn.onChange());
      });
    },
    /**
     * Determines if the current device is a mobile device.
     *
     * This function checks if the viewport width is less than or equal to 990 pixels,
     * which is typically used to distinguish mobile devices from tablets or desktops.
     *
     * @returns {boolean} True if the device is mobile, otherwise false.
     */
    isMobile: () => {
      return window.matchMedia("(max-width: 990px)").matches;
    },
    /**
     * Closes all the filter options lists on desktop devices.
     *
     * This function is called when the plugin is initialized.
     * It loops through all the filter title elements in the desktop filter options
     * and simulates a click on each one, which closes the filter options list.
     *
     * If the device is a mobile device, this function does nothing.
     */
    closeDesktopFilters: () => {
      if (_fn.isMobile()) return;

      _el.filterTitlesDesktop().forEach((item) => {
        item.click();
      });
    },
    /**
     * Updates the counter for the filter options in the desktop filter options list.
     *
     * This function is called when the filter options are initialized.
     * It loops through all the filter options in the desktop filter options list
     * and updates the counter for each option by counting the number of selected
     * filter options. The counter is displayed as a number with a leading zero if
     * the count is between 1 and 9. If the count is 0, the counter is hidden.
     *
     * @param {Element[]} optionsContainer The container element for all the filter options.
     */
    setCounter: (optionsContainer) => {
      setTimeout(() => {
        optionsContainer.forEach((option) => {
          const listOptionsLength = document.querySelectorAll(
            `#boost-sd__filter-tree-wrapper #${option.dataset.filteroptionid} .boost-sd__filter-option-item-button--selected`
          ).length;
          const listCounter = document.querySelector(
            `#boost-sd__filter-tree-wrapper #${option.dataset.filteroptionid}-toggle-target-label .boost-sd__counter.boost-sd__counter--filter-tree`
          );

          if (!listCounter) return;

          listCounter.innerHTML =
            listOptionsLength < 10 && listOptionsLength > 0
              ? `0${listOptionsLength}`
              : listOptionsLength <= 0
              ? ""
              : listOptionsLength;
        });

        setTimeout(() => {
          _fn.bindEvents();
        }, 1000);
      }, 500);
    },
    /**
     * Updates the counter for the filter options in the mobile filter options list.
     *
     * This function is called when the filter options are initialized.
     * It loops through all the filter options in the mobile filter options list
     * and updates the counter for each option by counting the number of selected
     * filter options. The counter is displayed as a number.
     *
     * @param {Element[]} optionsContainer The container element for all the filter options.
     */
    setCounterMobile: (optionsContainer) => {
      setTimeout(() => {
        optionsContainer.forEach((option) => {
          if (
            !option.dataset.filteroptionid ||
            option.dataset.filteroptionid === "pf_p_price"
          )
            return;

          const listOptionsLength = document.querySelectorAll(
            `#boost-sd_filter-tree-mobile #${option.dataset.filteroptionid} .boost-sd__filter-option-item-button--selected`
          ).length;
          const listCounter = document.querySelector(
            `#boost-sd_filter-tree-mobile #${option.dataset.filteroptionid}-toggle-target-label .boost-sd__counter.boost-sd__counter--filter-tree`
          );

          if (!listCounter) return;

          listCounter.innerHTML = listOptionsLength;
        });

        setTimeout(() => {
          _fn.bindEvents();
        }, 1000);
      }, 500);
    },
    /**
     * Updates the counter for all the filter options lists.
     *
     * This function is called whenever a filter option is clicked.
     * It loops through all the filter options lists and updates the counter
     * for each list by counting the number of selected filter options.
     *
     * If the device is a mobile device, this function will only update the counter
     * for the mobile filter options list.
     */
    onChange: () => {
      const optionsContainer = document.querySelectorAll(
        ".boost-sd__filter-option.boost-sd__filter-option-list"
      );

      if (!optionsContainer) return;

      _fn.setCounter(optionsContainer);
    },
  };

  setTimeout(() => {
    _fn.init();
  }, 1000);
});
